import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('equipmentDetails');

    return {
        TITLE: t('title')
    };
};

export default useTranslation;
